'use client';

import * as React from 'react';

import { Typography } from '@components/typography';

export const ListingReviewsScrollLink: React.FC = () => {
  const handleScrollToReviews = () => {
    const reviewsSection = document.getElementById('reviews');
    if (reviewsSection) {
      reviewsSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <button
      type="button"
      aria-label="Scroll to reviews section"
      className="ml-3 text-primary-main font-light hover:text-primary-light text-xs underline cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-main focus-visible:ring-offset-2 rounded"
      onClick={handleScrollToReviews}
    >
      <Typography variant="body2" component="span">
        See All Reviews
      </Typography>
    </button>
  );
};
